<ng-container *ngVar="shouldExpandSections$ | async as shouldExpandSections">
  <div
    *ngVar="chosenOptionsCount$ | async as chosenOptionsCount"
    class="bg-navy-90 h-16 flex-none flex flex-row justify-between items-center"
  >
    <div class="flex flex-row ml-5 items-center">
      <svg-icon id="filter-icon" class="flex h-6 w-6" [src]="'advanced-filter'"></svg-icon>
      <span class="font-main text-2xl font-bold whitespace-nowrap text-white flex ml-3">
        {{ buildTranslationKey('filters') | translate }}
        @if (chosenOptionsCount) {
          ({{ chosenOptionsCount }})
        }
      </span>
    </div>
    <div class="flex flex-row items-center mr-3">
      @if (chosenOptionsCount) {
        <app-new-button
          class="border-white text-white hover:bg-white hover:text-navy-90 reset mr-1 w-24"
          [type]="'secondary'"
          (click)="reset()"
        >
          {{ buildTranslationKey('clearFilters') | translate }}
        </app-new-button>
      }

      <app-cross-button id="collapse-filters" data-test-id="filter-close-btn" (click)="close()"></app-cross-button>
    </div>
  </div>
  <div class="flex-1 overflow-y-auto">
    <!-- NOTE: it's important to use ngFor in this case, with @for there are problems with rendering for some reason -->
    @for (field of fields$ | async; track fieldTrackBy(i, field); let i = $index) {
      <ng-container
        *ngTemplateOutlet="
          isFieldsGroup(field) ? groupTemplate : fieldTemplate;
          context: { item: field, afterExpandButton: i + 1 > maxVisibleSectionsAmount }
        "
      ></ng-container>

      @if (i + 1 === maxVisibleSectionsAmount) {
        <div class="flex flex-col px-5 gap-y-3 pb-3">
          <span class="h-px w-full bg-navy-40"></span>

          <app-new-button
            [size]="'stretch'"
            [verticalSize]="'small'"
            [type]="shouldExpandSections ? 'secondary' : 'primary'"
            [svgIconPath]="shouldExpandSections ? 'line' : 'Add'"
            (click)="changeExpandState()"
          >
            {{ buildTranslationKey(shouldExpandSections ? 'lessFiltersButton' : 'moreFiltersButton') | translate }}
          </app-new-button>
        </div>
      }
    }
  </div>

  <ng-template #fieldTemplate let-item="item" let-afterExpandButton="afterExpandButton">
    @if (item.displayed) {
      @if (afterExpandButton ? shouldExpandSections : true) {
        <app-data-filter-field
          [attr.data-test-id]="item.id"
          [fieldId]="item.id"
          [filterInstanceId]="currentfilterInstanceId"
        ></app-data-filter-field>
      }
    }
  </ng-template>

  <ng-template #groupTemplate let-item="item" let-afterExpandButton="afterExpandButton">
    @if (afterExpandButton ? shouldExpandSections : true) {
      <app-filter-fields-group
        [filterInstanceId]="currentfilterInstanceId"
        [fieldsGroup]="item"
      ></app-filter-fields-group>
    }
  </ng-template>
</ng-container>
